import React, { useState } from "react";
import LoginForm from "./LoginForm";
import SignupForm from "./SignupForm";
import ForgotPasswordForm from "./ForgotPasswordForm";
import OtpValidationForm from "./OtpValidationForm";
import PasswordChangeForm from "./PasswordChangeForm";
import {
  login,
  getUser,
  register,
  resetPassword,
  verifyOtp,
  updatePassword,
} from "../../util/AuthApiService";
import { useNavigate } from "react-router-dom";
import "./Auth.css";
import { useSnackbar } from "notistack";

const Auth = () => {
  const [currentForm, setCurrentForm] = useState("login");
  const [email, setEmail] = useState("");
  const navigate = useNavigate();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const handleLoginSubmit = (formData) => {
    login(formData)
      .then((response) => {
        if ((response.data = "Login Successful")) {
          getUser(formData.email).then((response) => {
            localStorage.setItem("users", JSON.stringify(response.data));
          });
          navigate("/");
        }
      })
      .catch((err) => {
        console.error("Failed to Login", err);
        enqueueSnackbar(err.response.data);
      });
  };

  const handleSignupSubmit = (formData) => {
    register(formData)
      .then((response) => {
        // getUser(formData.email).then((response) => {
        //   localStorage.setItem("users", JSON.stringify(response.data));
        // });
        // navigate("/");
      })
      .catch((err) => {
        console.error("Failed to Login", err);
        enqueueSnackbar(err.response.data);
      });
  };

  const handleForgotSubmit = (data) => {
    resetPassword({ email: data.email })
      .then((response) => {
        setEmail(data.email);
        setCurrentForm("otpValidation");
      })
      .catch((err) => {
        console.error("Failed to send OTP", err);
        enqueueSnackbar(err.response.data);
      });
  };

  const handleResendOtp = (data) => {
    resetPassword({ email }).catch((err) => {
      enqueueSnackbar(err.response.data);
    });
  };

  const handleOtpSubmit = (otp) => {
    verifyOtp({ email, otp })
      .then((response) => {
        setCurrentForm("passwordChange");
      })
      .catch((err) => {
        console.error("OTP validation failed", err);
        enqueueSnackbar(err.response.data);
      });
  };

  const handlePasswordChangeSubmit = (newPassword) => {
    updatePassword({ email, password: newPassword })
      .then((response) => {
        setCurrentForm("login");
      })
      .catch((err) => {
        console.error("Password change failed", err);
        enqueueSnackbar(err.response.data);
      });
  };

  const renderForm = () => {
    switch (currentForm) {
      case "login":
        return (
          <LoginForm
            onSubmit={handleLoginSubmit}
            switchToSignup={() => setCurrentForm("signup")}
            switchToForgotPassword={() => setCurrentForm("forgot")}
          />
        );
      case "signup":
        return (
          <SignupForm
            onSubmit={handleSignupSubmit}
            switchToLogin={() => setCurrentForm("login")}
          />
        );
      case "forgot":
        return (
          <ForgotPasswordForm
            email={email}
            onSubmit={handleForgotSubmit}
            switchToLogin={() => setCurrentForm("login")}
          />
        );
      case "otpValidation":
        return (
          <OtpValidationForm
            onSubmit={handleOtpSubmit}
            onResendOtp={handleResendOtp}
            switchToForgotPassword={() => setCurrentForm("forgot")}
          />
        );
      case "passwordChange":
        return (
          <PasswordChangeForm
            onSubmit={handlePasswordChangeSubmit}
            switchToLogin={() => setCurrentForm("login")}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-content">
        <div className="auth-image">
          <img
            src="loginscreen.png"
            alt="Shopping cart with mobile phone"
            className="signup-image"
          />
        </div>
        <div className="auth-form-container">
          <div className="auth-form-content">{renderForm()}</div>
        </div>
      </div>
    </div>
  );
};

export default Auth;
